import React from 'react';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      {/* 头部导航 */}
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div className={styles['screen1-title']}></div>
          <div className={styles['screen1-desc']}>
            爱学AI自然拼读，AI一对一英语教学产品的领先者。根据学员不同阶段特点构建全维度语言培养系统，依托强大的爱学大模型带给用户革命性交互体验，首个教育级数字人技术打造超真人一对一效果。
          </div>
        </div>
      </div>
    </section>
  );
}
